<template>
  <nav class="navbar navbar-expand navbar-dark bg-dark purple darken-4">
    <router-link to="/" class="navbar-brand" href="/" style="-webkit-app-region: drag">
      <img src="../../assets/4p_logo_white.png" height="40"/>
    </router-link>

    <div class="navbar-collapse" id="navbar">
      <ul class="navbar-nav mr-auto mt-2 mt-lg-0" v-if="!loggedin">
        <li class="nav-item">
          <router-link to="/login" class="nav-link">Login</router-link>
        </li>
      </ul>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item" v-if="loggedin">
          <router-link to="/" class="nav-link">
            <lock-clock-icon/>
            Authenticators
          </router-link>
        </li>
        <li class="nav-item">
          <a href="#" class="nav-link" @click="showHelp">
            <help-circle-outline-icon/>
            Help
          </a>
        </li>
        <li v-if="loggedin" class="nav-item">
          <router-link to="/settings" class="nav-link">
            <settings-icon/>
            Settings
          </router-link>
        </li>
        <li v-if="loggedin&&okey" class="nav-item">
          <a class="nav-link" href="javascript:;;" @click="logoutUser">
            <lock-icon/>
            Lock
          </a>
        </li>
        <li v-if="loggedin&&!okey" class="nav-item">
          <a class="nav-link" href="javascript:;;" @click="logoutUser">
            <close-icon/>
            Logout
          </a>
        </li>

      </ul>
    </div>
  </nav>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import EventHub from '../../events/event-hub';

  import HelpCircleOutlineIcon from "vue-material-design-icons/HelpCircleOutline";
  import SettingsIcon from "vue-material-design-icons/Settings";
  import CloseIcon from "vue-material-design-icons/Close";
  import LockClockIcon from "vue-material-design-icons/LockClock";
  import LockIcon from "vue-material-design-icons/Lock.vue";

  export default {
    components: {
      LockIcon,
      SettingsIcon,
      CloseIcon,
      HelpCircleOutlineIcon,
      LockClockIcon
    },
    name: 'site-navigation',
    data() {
      return {};
    },
    computed: {
      ...mapGetters({
        loggedin: 'auth/loggedin',
        isAdmin: 'auth/isAdmin',
        currentUser: 'auth/user',
        okey: 'settings/okey',
      })
    },
    methods: {
      ...mapActions({
        logout: 'auth/logout',
        setDelayedFeedback: 'feedback/setDelayedFeedback'
      }),
      showHelp() {
        EventHub.$emit('help-show');
      },
      logoutUser() {
        this.logout()
          .then(() => {
            this.$router.push({name: 'login'});
            //return document.location.reload();
          });
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/SiteNavigation.vue